import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CalendarWeek } from '../../pages/employees-tabs/arbeitszeit/arbeitszeit.page';
import { WorkTimerecorddetail, WorkTimerecorddetailsByDateDto } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-timerecorddetails-list',
  templateUrl: './ax-timerecorddetails-list.component.html',
  styleUrls: ['./ax-timerecorddetails-list.component.scss'],
})
export class AxTimerecorddetailsListComponent implements OnInit {
  @Input() timerecorddetailsByDateDto: WorkTimerecorddetailsByDateDto;
  @Input() selectedCalendarWeek: CalendarWeek | undefined;
  public isPopoverLockedOpen: WorkTimerecorddetail | undefined;
  public isPopoverSentToAgentOpen: WorkTimerecorddetail | undefined;
  protected readonly moment = moment;

  constructor() {
  }

  public ngOnInit() {
  }
}
